module.exports = __webpack_public_path__ + "static/img/quarter-pipe_256.4d14e9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/quarter-pipe_256.png
// module id = h4mj
// module chunks = 0